import { render, staticRenderFns } from "./addUpdateUser.vue?vue&type=template&id=5a8e8121"
import script from "./addUpdateUser.vue?vue&type=script&lang=js"
export * from "./addUpdateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports